import React from 'react';
import Button from '../common/Button';
import { CourseEvaluationDTO } from '../../services/apiClient';
import { getBadgeColors } from '../../utils/displayUtils';
import Badge from '../common/Badge';
import Table from '../common/Table';
import Tippy from '@tippyjs/react';
import { Download } from 'lucide-react';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface CourseEvaluationProps {
  courseEvaluation: CourseEvaluationDTO[];
  onClose: () => void;
}



const CourseEvaluation: React.FC<CourseEvaluationProps> = ({
  courseEvaluation,
  onClose,
}) => {
  const columns = [
    {
      label: 'Status',
      key: 'evaluationStatus',
      render: (row: CourseEvaluationDTO) => {
        const rowBase = row.evaluationStatus?.colourGrading?.colour ?? '#ffffffff';
        const rowColors = getBadgeColors(rowBase, 0.18, 0.4);

        return (
          <Badge
            label={row.evaluationStatus?.title || 'Unknown'}
            variant="custom"
            customBgColor={rowColors.bg}
            customTextColor={rowColors.text}
          />
        );
      },
    },
    {
      label: 'Score',
      key: 'scoreMark',
      format: (value: any, row: CourseEvaluationDTO) =>
        `${row.scoreMark} / ${row.scorePercentage}%`,
    },
    {
      label: 'Course',
      key: 'courseType',
      format: (value: any, row: CourseEvaluationDTO) =>
        row.courseType?.title || '',
    },
    {
      label: 'Time',
      key: 'startTime',
      format: (value: any, row: CourseEvaluationDTO) =>
        `${row.startTime ? convertToUserTime(row.startTime.toString()) : '-'} → ${row.endTime ? convertToUserTime(row.endTime.toString()) : '-'}`,
    },
    {
      label: 'Action',
      key: 'action',
      render: () => (
        <Tippy content="Download">
          <button
            type="button"
            onClick={() => { }
            }
            className="text-white bg-primary p-2 cursor-pointer"
          >
            <Download className="h-4 w-4" />
          </button>
        </Tippy>
      ),
    },
  ];

  return (
    <>
      {courseEvaluation.length > 0 ? (
        <>
          <Table
            columns={columns}
            data={courseEvaluation}
            isLoading={false}
            allowPaging={false}
            expandableDetails={false}
            noDataMessage="No items listed"
          />

          <div className="mt-4 p-4 bg-gray-50 rounded-lg text-sm text-gray-600 dark:bg-gray-700 dark:text-gray-300">
            {courseEvaluation.map((evaluation, index) => (
              <div
                key={evaluation.id ?? `${evaluation.startTime ?? 'evaluation'}-${index}`}
                className={index > 0 ? 'space-y-1 pt-3 mt-3 border-t border-gray-200 dark:border-gray-600' : 'space-y-1'}
              >
                <div><span className="font-semibold">IP:</span> {evaluation.ip || 'N/A'}</div>
                <div><span className="font-semibold">User Agent:</span> {evaluation.userAgent || 'N/A'}</div>
                <div><span className="font-semibold">Browser ID:</span> {evaluation.cookieGuid || 'N/A'}</div>
              </div>
            ))}
          </div>

          <div className="flex justify-end space-x-4 mt-4">
            <Button variant="secondary" onClick={onClose}>
              Close
            </Button>
          </div>
        </>
      ) : (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg text-sm text-gray-600">
          <span>No items listed</span>
        </div>
      )}
    </>
  );
};

export default CourseEvaluation;
